var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgActionCopy = function SvgActionCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-1232 -651) translate(1232 651)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-17054-16983a2 2 0 0 1-2-2v-3h-2a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v3h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2z",
    transform: "translate(-1232 -651) translate(0 -1) translate(18297 17656)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#108060",
    d: "M-17048-16983.998c.55 0 1-.451 1-1.004v-9c0-.55-.45-1-1-1h-3v-3.996c0-.553-.447-1.004-.998-1.004h-6.004c-.55 0-1 .451-1 1.004v9c0 .55.45.998 1 .998h3.004v3.998c0 .553.45 1.004 1 1.004h5.998m0 1h-5.998c-1.11 0-2-.895-2-2.004v-2.998h-2.004c-1.103 0-2-.895-2-1.998v-9c0-1.11.897-2.004 2-2.004h6.004c1.103 0 1.998.895 1.998 2.004v2.996h2c1.105 0 2 .895 2 2v9c0 1.11-.895 2.004-2 2.004z",
    transform: "translate(-1232 -651) translate(0 -1) translate(18297 17656)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#108060",
    strokeLinejoin: "round",
    d: "M1241.436 666.49l5.064-.061v-6.865",
    transform: "translate(-1232 -651)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActionCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/action-copy.e019dbec.svg";
export { ForwardRef as ReactComponent };